module.exports = __webpack_public_path__ + "static/omega_g6-3946d4f9fa55ca56d9366e3a3f75405e.jpg";